export { default as Heading } from './Heading';
export * from './useHeadingStyleProps';
